/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Connect_Gallery_DescriptionInputs */



/**
* | output |
* | --- |
* | "Show the “Connect a source” cards on the Spaces page." |
*
* @param {Preferences_Connect_Gallery_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_connect_gallery_description = /** @type {((inputs?: Preferences_Connect_Gallery_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Connect_Gallery_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Karten „Quelle verbinden“ auf der Spaces-Seite anzeigen.")
	return /** @type {LocalizedString} */ ("Show the “Connect a source” cards on the Spaces page.")
});